export enum DataLineageNodeBinding {
  FilterHighlights = 'highlights',
  FixedPosition = 'fixedPosition',
  LayerName = 'layerName',
  Location = 'location',
  Logo = 'logo',
  Name = 'name',
  $Name = '$name',
  Status = 'status',
  AssetStatus = 'assetStatus',
  ZOrder = 'zOrder',
  PathSelection = 'pathSelection',
  Active = 'active',
  Peeked = 'peeked',
  ItemType = 'itemType',
  Tags = 'tags',
  DeletedEntity = 'deletedEntity',
  HasReadPermission = 'hasReadPermission',
  ValidColumnsCount = 'validColumnsCount',
}
